import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { emailAddressCountry, country, thanksCountry } from './country-steps'

export const countryScenarioA: Scenario = {
  id: 'country-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.COUNTRY,
  version: '1',
  milestones: [emailAddressCountry.id, country.id, thanksCountry.id],
  steps: [emailAddressCountry, country, thanksCountry],
  weight: 1,
}
